<!-- <app-cpl-task></app-cpl-task>
<app-cpl-event></app-cpl-event>
<app-cpl-submit></app-cpl-submit>
<app-cpl-download></app-cpl-download>-->
<div *ngFor="let task of customerTasks; let last = last">
    <app-cpl-task *ngIf="task.tasktype=='task' || !task.tasktype" [taskTitle]="task.title"
        [taskDescription]="task.description" [taskState]="task.taskstate" [taskType]="task.tasktype"
        [canEdit]="task.canEdit" (taskaction)="taskAction(task)">
    </app-cpl-task>
    <app-cpl-task *ngIf="task.tasktype=='link'" [taskTitle]="task.title" [taskType]="task.tasktype"
        [taskDescription]="task.description" [taskState]="task.taskstate" [linkurl]="task.linkurl"
        [linktext]="task.linktext" [canEdit]="task.canEdit" (taskaction)="taskAction(task)"></app-cpl-task>
    <app-cpl-task *ngIf="task.tasktype=='form'" [taskTitle]="task.title" [taskType]="task.tasktype"
        [taskDescription]="task.description" [taskState]="task.taskstate" [canEdit]="task.canEdit"
        [formTemplateId]="task.formTemplateId" [formTemplateVersion]="task.formTemplateVersion"
        [formTemplateName]="task.formTemplateName" (taskaction)="taskAction(task)"></app-cpl-task>
    <app-cpl-event *ngIf="task.tasktype=='event'" [taskState]="task.taskstate" [taskTitle]="task.title"
        [taskDescription]="task.description" [taskStart]="task.startdate" [taskEnd]="task.duedate"
        [canEdit]="task.canEdit" (eventaction)="eventAction($event)">
    </app-cpl-event>
    <app-cpl-submit *ngIf="task.tasktype=='submit'" [taskState]="task.taskstate" [taskTitle]="task.title"
        [taskDescription]="task.description" [canEdit]="task.canEdit" (submitaction)="openUploadModal(task)">
    </app-cpl-submit>
    <app-cpl-download *ngIf="task.tasktype=='download'" (downloadaction)="downloadAction(task)" [linkurl]="task.linkurl"
        [linktext]="task.linktext" [taskState]="task.taskstate" [taskTitle]="task.title" [canEdit]="task.canEdit"
        [taskDescription]="task.description">
    </app-cpl-download>
    <ng-container *ngIf="last">
        {{ onLoopFinished() }}
    </ng-container>
</div>


<!--- Image upload modal --->
<!-- Button trigger modal 
<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#imageuploadmodal">
    Launch demo modal
</button>-->

<!-- Modal -->
<div class="modal fade" id="imageuploadmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'imageupload.title' | trans }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-imageupload [imagewidth]="200" [filename]="'example small'"></app-imageupload>
            </div>
        </div>
    </div>
</div>

<!-- Upload Modal (only if there is more than one file required!) -->
<div class="modal fade" id="uploadmodal" tabindex="-1" role="dialog" aria-labelledby="uploadmodaltitle"
    aria-hidden="true">
    <!-- <app-fileupload (fileUploaded)="newFile($event)" [filetype]="'task'" [index]="modalTask?.taskId"
        [organizationId]="organizationId" [projectId]="projectId" [customerId]="customerId"></app-fileupload> -->

    <app-loadconfirm [@inbgOutAnimation] *ngIf="!contentPrinted" [modalloader]="true"
        [icon]="'pending'"></app-loadconfirm>
    <div [@inbgOutAnimation] [ngClass]="{'d-none': !contentPrinted}" class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{ 'cpllist.submit' | trans }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!---<div class="mb-2">
                    <a data-toggle="collapse" class="d-inline cursor-pointer" href=" #filelistcollapse">
                        <p class="f-15 d-inline align-middle lh-20 cursor-pointer">Files</p><span
                            class="material-icons d-inline align-middle lh-20 cursor-pointer">
                            keyboard_arrow_down
                        </span>
                    </a>
                </div>
                <div class="collapse" id="filelistcollapse">
                    <app-filelist *ngIf="modalTask?.uploadFields?.length > 0" [textColor]="true" [list]="false"
                        [projectId]="projectId" [filetype]="'task'" [viewtype]="'modal'"
                        [entityid]="modalTask?.taskId"></app-filelist>
                </div>--->
                <div *ngFor="let filename of modalTask?.uploadFields; let last = last" class="">
                    <!---<label for="formFileSm" class="form-label">{{ filename }}</label>--->
                    <app-fileupload (filelistUpdated)="filelistUpdated($event)" (fileUploaded)="newFile($event)"
                        (fileDeleted)="onFileDeleted($event)" [filetype]="'task'" [taskInputName]="filename"
                        [index]="modalTask?.taskId" [downloadtoggle]="true" [organizationId]="organizationId"
                        [projectId]="projectId" [customerId]="customerId" [modal]="false"></app-fileupload>
                    <ng-container *ngIf="last && !contentPrinted && filelistUpdatedvalue">
                        {{ onContentPrinted() }}
                    </ng-container>
                </div>
                <!-- <button [disabled]="!fileselected" type="button" data-dismiss="modal" aria-label="Close"
                    class="btn mt-2 btn-noround">
                    <p class="btn-text mb-0" style="font-weight: 500;">{{ 'cpllist.submit' | trans }}</p>
                </button> -->
            </div>
            <div class="row" style="margin-left:5px; margin-right:5px; margin-bottom: 10px;">
                <div class="col">
                    <button id="closesavestage" type="button" data-dismiss="modal" class="btn-save float-left w-100">
                        <h6 class="btn-save-text">{{ 'customerdeallist.done' | trans }}</h6>
                    </button>
                </div>

            </div>
        </div>
    </div>
</div>
<!-- Upload Modal end  -->
<!-- Form Modal Loading Overlay -->
<div *ngIf="formModalLoading" class="modal-loading-overlay">
  <app-loadconfirm 
    [modalloader]="true"
    [icon]="'pending'">
  </app-loadconfirm>
</div>
<!-- Download Modal (only if there is more than one file required!)-->
<div class="modal fade" id="downloadmodal" tabindex="-1" role="dialog" aria-labelledby="downloadmodaltitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{ 'cpllist.downloadtemplates' | trans }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>{{ 'cpllist.downloadbody' | trans }}</p>
                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        {{ modalTask?.linktext }}
                        <a href="{{ modalTask?.linkurl }}" download="skabelon">
                            <button class="btn btn-noround" type="button">
                                <p class="btn-text" style="font-weight: 500;">{{ 'projectstage.tasktypedownload' | trans
                                    }}</p>
                            </button></a>
                        <!-- <li class="list-group-item d-flex justify-content-between align-items-center">
                        Relevant data
                        <button class="btn">
                            <p class="btn-text">Download</p>
                        </button>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        Other relevant data
                        <button class="btn">
                            <p class="btn-text">Download</p>
                        </button>
                    </li> -->
                </ul>


            </div>
        </div>
    </div>
</div>
<!-- Download Modal end -->